import React from 'react';
import * as FiIcons from 'react-icons/fi';
import { Button } from './ui/Button';
import SafeIcon from '../src/common/SafeIcon';

const { FiShield, FiPlayCircle } = FiIcons;

export const Hero: React.FC = () => {
  return (
    <section className="relative bg-slate-50 pt-32 pb-24 lg:pt-48 lg:pb-32 overflow-hidden">
      <div className="absolute top-0 right-0 -translate-y-12 translate-x-1/4 w-[800px] h-[800px] bg-brand-100/40 rounded-full blur-3xl pointer-events-none"></div>
      <div className="absolute bottom-0 left-0 translate-y-1/4 -translate-x-1/4 w-[600px] h-[600px] bg-accent-100/40 rounded-full blur-3xl pointer-events-none"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-8 items-center">
          <div className="max-w-2xl">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white border border-brand-100 shadow-sm text-brand-900 text-sm font-semibold mb-8">
              <SafeIcon icon={FiShield} className="w-4 h-4 text-brand-600" />
              <span>Fiduciary-Aligned Education</span>
            </div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-slate-900 leading-[1.1] mb-6 tracking-tight">
              Digital Assets <br/>
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-800 to-brand-500">Literacy</span>
            </h1>
            <p className="text-lg md:text-xl text-slate-600 mb-8 leading-relaxed max-w-lg">
              A compliance-aware training for financial advisors who want to confidently explain Bitcoin and digital assets—without hype, and without crossing regulatory boundaries.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 mb-12">
              <Button size="lg" variant="primary" className="shadow-lg shadow-brand-900/20">
                Start the Mini-Course
              </Button>
              <a href="#curriculum">
                 <Button size="lg" variant="outline" className="bg-white/50 backdrop-blur-sm">
                    Preview Curriculum
                 </Button>
              </a>
            </div>
          </div>

          <div className="relative lg:h-[600px] flex items-center justify-center">
             <div className="relative w-full aspect-square max-w-[500px]">
                <div className="absolute inset-0 rounded-[2rem] overflow-hidden shadow-2xl rotate-3 hover:rotate-0 transition-transform duration-700 ease-out">
                    <img src="https://images.unsplash.com/photo-1639322537228-f710d846310a?auto=format&fit=crop&w=1000&q=80" alt="Abstract" className="w-full h-full object-cover" />
                    <div className="absolute inset-0 bg-gradient-to-t from-slate-900/60 to-transparent"></div>
                </div>
                <div className="absolute -left-4 top-12 bg-white/90 backdrop-blur-md p-4 rounded-xl shadow-xl border border-white/20 max-w-[200px] animate-bounce">
                    <div className="flex items-center gap-3 mb-2">
                        <div className="w-8 h-8 rounded-full bg-green-100 flex items-center justify-center">
                            <SafeIcon icon={FiShield} className="w-4 h-4 text-green-600" />
                        </div>
                        <span className="text-xs font-bold text-slate-800">Compliance Ready</span>
                    </div>
                </div>
                <div className="absolute -right-4 bottom-24 bg-white/90 backdrop-blur-md p-4 rounded-xl shadow-xl border border-white/20">
                     <div className="flex items-center gap-3">
                        <div className="w-10 h-10 rounded-full bg-brand-100 flex items-center justify-center">
                            <SafeIcon icon={FiPlayCircle} className="w-5 h-5 text-brand-600" />
                        </div>
                        <div>
                            <p className="text-xs text-slate-500">Course Progress</p>
                            <p className="text-sm font-bold text-slate-900">Module 3: Mining</p>
                        </div>
                    </div>
                </div>
             </div>
          </div>
        </div>
      </div>
    </section>
  );
};